// Demo config for the Enverus-tenant deploy (SWA: WellChron-Demo, API: wellchron-demo-api).
//
// Selected by `ng build --configuration enverus-test` (= `npm run build:enverus-test`),
// which angular.json file-replaces over environment.ts.
//
// Same demo build as environment.test.ts, just pointed at the Enverus-tenant
// resources (subscription ea-well-data-exchange-dev, rg-wellchron-dev-cus)
// instead of the PDS-tenant ones. redirect_uri/apiConfig.uri use the Enverus
// custom domains (ITI-10065): wellchron-dev (site) and wellchron-int-dev (backend API).
//
// The Auth0 application must allow this redirect_uri as a callback/logout/web
// origin before sign-in will work here -- tenant config outside this repo.

export const environment = {
  production: true,
  auth0: {
    domain: 'login.auth.enverus.dev',
    clientId: 'pGktfSgCUF3J7lURbU5e9atoMysvtm5G',
    authorizationParams: {
      redirect_uri: 'https://wellchron-dev.enverus.com/callback',
      audience: 'https://api.enverus.com',
    },
  },
  apiConfig: {
    uri: 'https://wellchron-int-dev.enverus.com/',
  },
  mapbox: {
    accessToken: 'pk.eyJ1IjoicGRzZW5lcmd5IiwiYSI6ImNqdWN3dDI0azBudms0NHF5MncxemJrODgifQ.XLVw-KwRcQUkYMz6W6V_ZQ',
    style: 'mapbox://styles/pdsenergy/ck5psat0k1lhy1iphc0epoxkw',
    defaultZoom: 8,
    defaultLng: -103.432314,
    defaultLat: 31.644495
  }
};
